module.exports = __webpack_public_path__ + "static/img/ent-detail-44.d07db2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-44.jpg
// module id = anVK
// module chunks = 51